/* eslint-disable */
const gift = {
  state: {
    scrollTop: 0
  },

  mutations: {
    SET_GIFT_LIST_SCROLL_TOP: (state, y) => {
      state.scrollTop = y
    }
  },

  actions: {
    SetGiftListScrollTop({ commit }, y) {
      commit('SET_GIFT_LIST_SCROLL_TOP', y)
    }
  }
}

export default gift
